<template>

    <div class="container">

        <app-head title="Messages" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Messages') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.messages.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="message_type" v-model="form.message_type">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="k" v-for="(v, k) in messageTypeOptions">{{ v }}</option>
                </select-input>
                <select-input label="Status" v-model="form.status">
                    <option :value="null">{{ __('Veröffentlicht') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="messages.meta" />
        </div>

        <div class="card">
            <data-table :items="messages.data"
                        :links="messages.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="message in messages.data" :key="message.id">
                    <td>
                        {{ message.id }}
                    </td>
                    <td>
                        {{ message.created_at | localizeDateTime }}
                    </td>
                    <td>
                        {{ message.message_type }}
                    </td>
                    <td>
                        <inertia-link class="stretched-link" :href="route('admin.messages.edit', message)">
                            {{ message.subject }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ message.clean_text | truncateWords }}
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import Results from '@/shared/Admin/Results';


    export default {
        props: [
            'filters',
            'messages',
            'messageTypeOptions',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                    message_type: this.filters.message_type,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    created_at: {label: 'Created', sortable: 'created_at'},
                    message_type: {label: 'Type', sortable: 'message_type'},
                    subject: {label: 'Subject', sortable: 'subject'},
                    text: {label: 'Text', sortable: 'text'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.messages.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>